// Original brochure content, corrected to landscape without rasterization. Logo unchanged.
export const COMPANY_BROCHURE = {
  url: "/brochure/brochure-aziendale-gfc-2026-2027-orizzontale.pdf",
  filename: "Brochure_Aziendale_GFC_Appalti_Generali_2026-2027_Orizzontale.pdf",
  pages: 17,
  bytes: 4246151,
  logo: "/brand/gfc-logo-originale.png",
};